import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductCarouselItemComponent, ProductListItemContext, ProductListItemContextSource } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-carousel-item',
  standalone: false,
  templateUrl: './custom-carousel-item.component.html',
  styleUrl: './custom-carousel-item.component.scss',
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCarouselItemComponent extends ProductCarouselItemComponent{
}
